import { render, staticRenderFns } from "./Count.vue?vue&type=template&id=90b95258&scoped=true"
import script from "./Count.vue?vue&type=script&lang=ts"
export * from "./Count.vue?vue&type=script&lang=ts"
import style0 from "./Count.vue?vue&type=style&index=0&id=90b95258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b95258",
  null
  
)

export default component.exports